module.exports = __webpack_public_path__ + "static/imageBootcamp2-fa0e2f3018b2a72dcb2d2a56a3c3f0f8.png";